// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.5}
      d="M18.6666 14.6667H10.6666M13.3333 20H10.6666M21.3333 9.33334H10.6666M26.6666 14V9.06667C26.6666 6.82646 26.6666 5.70636 26.2307 4.85071C25.8472 4.09806 25.2353 3.48614 24.4826 3.10265C23.627 2.66667 22.5069 2.66667 20.2666 2.66667H11.7333C9.4931 2.66667 8.373 2.66667 7.51735 3.10265C6.7647 3.48614 6.15278 4.09806 5.76929 4.85071C5.33331 5.70636 5.33331 6.82646 5.33331 9.06667V22.9333C5.33331 25.1735 5.33331 26.2937 5.76929 27.1493C6.15278 27.9019 6.7647 28.5139 7.51735 28.8974C8.373 29.3333 9.4931 29.3333 11.7333 29.3333H15.3333M29.3333 29.3333L27.3333 27.3333M28.6666 24C28.6666 26.5773 26.5773 28.6667 24 28.6667C21.4227 28.6667 19.3333 26.5773 19.3333 24C19.3333 21.4227 21.4227 19.3333 24 19.3333C26.5773 19.3333 28.6666 21.4227 28.6666 24Z"
    />
  </svg>
);
const IconFileSearch = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconFileSearch;
